import isArray from 'lodash/isArray';
import sortBy from 'lodash/sortBy';
import React from 'react';
import { isNumOrStr } from '../../../utils/isNumOrStr';
import { roundValue } from '../../../utils/math';
import { TooltipWrapper } from '../../reports/utils/Utils';

// tslint:disable-next-line:no-any
const defaultFormatter = (value: any): string =>
  isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1])
    ? value.join(' ~ ')
    : value;

// tslint:disable-next-line:no-any
export const CustomTooltip = (props: any): React.ReactElement => {
  const { payload, separator, formatter, itemStyle, itemSorter } = props;

  if (payload && payload.length) {
    const listStyle = { padding: 0, margin: 0 };

    const items = (itemSorter ? sortBy(payload, itemSorter) : payload).map(
      (entry, i) => {
        if (entry.type === 'none') {
          return null;
        }

        const finalItemStyle = {
          display: 'block',
          color: 'var(--color-text)',
          ...itemStyle,
        };
        const finalFormatter = entry.formatter || formatter || defaultFormatter;
        let { name, value } = entry;
        if (finalFormatter) {
          const formatted = finalFormatter(value, name, entry, i);
          if (Array.isArray(formatted)) {
            [value, name] = formatted;
          } else {
            value = formatted;
          }
        }
        const valueFormatter = getRoundingFormatter(name);

        return (
          <React.Fragment key={`tooltip-item-${i}`}>
            <li className='recharts-tooltip-item' style={finalItemStyle}>
              {isNumOrStr(name) ? (
                <span
                  className='recharts-tooltip-item-name'
                  style={{ textShadow: '1px 1px #000' }}
                >
                  {name}
                </span>
              ) : null}
              {isNumOrStr(name) ? (
                <span
                  className='recharts-tooltip-item-separator'
                  style={{ textShadow: '1px 1px #000' }}
                >
                  {separator}
                </span>
              ) : null}
              <span
                className='recharts-tooltip-item-value'
                style={{ textShadow: '1px 1px #000' }}
              >
                {valueFormatter(value)}
              </span>
              <span
                className='recharts-tooltip-item-unit'
                style={{ textShadow: '1px 1px #000' }}
              >
                {entry.unit || ''}
              </span>
            </li>
          </React.Fragment>
        );
      }
    );
    const timeItem = (): React.ReactElement =>
      payload[0].payload.Time ? (
        <React.Fragment key='tooltip-item-00'>
          <li
            className='recharts-tooltip-item'
            style={{ display: 'block', color: 'var(--color-text)' }}
          >
            <span
              className='recharts-tooltip-item-name'
              style={{ textShadow: '1px 1px #000' }}
            >
              Time
            </span>
            <span
              className='recharts-tooltip-item-separator'
              style={{ textShadow: '1px 1px #000' }}
            >
              {separator}
            </span>

            <span
              className='recharts-tooltip-item-value'
              style={{ textShadow: '1px 1px #000' }}
            >
              {roundValue(
                payload[0].payload.Time / payload[0].payload.Hertz,
                2
              )}
            </span>
          </li>
        </React.Fragment>
      ) : null;
    return (
      <TooltipWrapper className='recharts-default-tooltip'>
        <ul className='recharts-tooltip-item-list' style={listStyle}>
          {timeItem()}
          {items}
        </ul>
      </TooltipWrapper>
    );
  }

  return null;
};

const getRoundingFormatter = (item: string): ((val: number) => number) => {
  switch (item) {
    case 'Velocity':
      return (val: number): number => roundValue(val, 2);
    case 'Power':
      return (val: number): number => roundValue(val, 0);
    case 'Displacement':
      return (val: number): number => roundValue(val, 2);
    case 'Data Set A':
    case 'Data Set B':
      return (val: number): number => roundValue(val, 0);
    default:
      return (val: number): number => val;
  }
};
